import { useState, useEffect, useRef } from "react";
import { APIGet } from '@tccshared/services/API'


export const getTCCEvents = async (site, { month, year, category, view, ics = null }) => {

    try {
        let url = site + '/api/v1/events';

        let qs = [];

        if (month) qs.push('month=' + month);
        if (year) qs.push('year=' + year);
        if (category) qs.push('category=' + category);
        if (view) qs.push('view=' + view)
        if (ics) qs.push('ics=' + ics);

        let queryString = qs.join('&');
        url += '?' + queryString;


        const res = await APIGet(url)
        const json = await res.json();
        return { status: 'success', data: json };
    } catch (error) {
        return error;
    }

}

export const getPCOCalendarEvents = async (site, { month, year, category, view, start, end }) => {

    try {
        let url = site + '/api/v1/pco/v2/calendar';

        let qs = [];

        if (month) qs.push('month=' + month);
        if (year) qs.push('year=' + year);
        if (category) qs.push('category=' + category);
        if (view) qs.push('view=' + view)
        if (start) qs.push('starts_at=' + start)
        if (end) qs.push('ends_at=' + end)

        let queryString = qs.join('&');
        url += '?' + queryString;
        // Send Request To Get Events
        const res = await APIGet(url)
        const json = await res.json();
        return { status: 'success', data: json };
    } catch (error) {

    }

}


export const useEvents = (initialArgs = {}, site) => {

    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState(null);
    const request = useRef(null);

    const load = async (args = {}) => {
        const reference = Symbol('request')
        request.current = reference;
        setLoading(true);
        let res;
        const requestArgs = { ...initialArgs, ...args };
        await new Promise(r => setTimeout(r, 3000));
        if (requestArgs?.type === 'pcocalendar') res = await getPCOCalendarEvents(site, requestArgs)
        else res = await getTCCEvents(site, requestArgs);

        // If not current then return there is another request pending
        if(request.current !== reference) return;

        if (res.status === 'success') {
            setResult(res.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
        // Reset Request ref
        request.current = null;
    }

    useEffect(() => {
        if (!site) return;
        load();
    }, [site])

    return {
        load,
        loading,
        result
    }

}

